import { useContextState } from "../../../../hooks/theme"

export const useStyles = () => {
  const { colors } = useContextState()
  return {
    icons: {
      svg: {
        color: colors.primary
      }
    },
    buttons: {
      display: 'flex',
      gap: 4,
      padding: 1,
      '& .flex-col': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: .5
      }
    },
    clean: {
      fontSize: '2rem',
      '& .MuiSvgIcon-root': {
        fontSize: '1em',
      },
    },
    hide: {
      visibility: 'hidden',
    },
  }

}